// login_url — PURE. L'adresse qui démarre une connexion.
//
// ── POURQUOI UNE FONCTION ───────────────────────────────────────────────────
//
// Elle était un gabarit de chaîne au milieu de `auth.ts`. Ça suffisait tant qu'elle portait trois
// morceaux ; elle en porte un quatrième depuis le 2026-10-07 — le jeton du contrôle anti-robot —
// et ce quatrième a une règle : il n'apparaît QUE s'il existe.
//
// Une demande ordinaire doit rester exactement l'adresse d'hier. Un `&cf=` vide dirait au serveur
// « voici un jeton » en lui tendant le vide, et il refuserait — alors que ce qu'on veut dire est
// « il n'y a pas de contrôle ici ». C'est la même règle que `run_body` tient pour le corps d'une
// demande de run, et pour la même raison.

export type LoginParts = {
  /** L'adresse du service d'identité, sans barre finale. */
  readonly authBase: string;
  /** Le slug de l'app qui demande la connexion. */
  readonly app: string;
  /** Où revenir une fois connecté. Adresse absolue. */
  readonly returnTo: string;
  /** Le jeton du contrôle anti-robot, quand il y en a un. */
  readonly cfToken?: string | null;
};

export function loginUrl(parts: LoginParts): string {
  const base = parts.authBase.replace(/\/+$/, "");
  const q = new URLSearchParams({ app: parts.app, return: parts.returnTo });
  // UN JETON VIDE N'EST PAS UN JETON. `URLSearchParams` écrirait `cf=` tel quel, et le serveur
  // lirait une chaîne vide — qu'il refuse, à juste titre. L'absence se dit en se taisant.
  const cf = typeof parts.cfToken === "string" ? parts.cfToken.trim() : "";
  if (cf !== "") q.set("cf", cf);
  return `${base}/start/google?${q.toString()}`;
}
